import { render, staticRenderFns } from "./BestOffersBlock.vue?vue&type=template&id=45fbd5f0&scoped=true"
import script from "./BestOffersBlock.vue?vue&type=script&lang=ts"
export * from "./BestOffersBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fbd5f0",
  null
  
)

export default component.exports